import React from "react";
import { Label, UnstyledButton } from "src/ui";
import "./RainbowButton.scss";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { SearchLoader } from "src/components/MainHeaderSearch/SearchLoader";

interface IProps {
    text: string;
    onClick: (data: any) => any;
    onClickData: any;
    isLoading: boolean;
    isEnabled: boolean;
}

const RainbowButton = (props: IProps) => {
    return (
        <UnstyledButton
            className={["RainbowButton", ...(props.isEnabled ? ["enabled"] : [])].join(" ")}
            disabled={!props.isEnabled || props.isLoading}
            onClick={props.onClick}
            onClickData={props.onClickData}>
            <div className="RainbowButton-inner">
                <Label size="body-2" weight="medium" color="grey">{props.text}</Label>
                {!props.isLoading && (
                    <Visage2Icon
                        size="small"
                        color={props.isEnabled ? "transparent" : "grey"}
                        icon="sparkling-fill"
                        type="custom"
                    />
                )}

                {props.isLoading && <SearchLoader size={16} />}
            </div>
        </UnstyledButton>
    )
}

export default RainbowButton;
